module.exports = __webpack_public_path__ + "static/media/Surgicals.3ebecedc.png";